export default __webpack_public_path__ + "static/media/water-upper.b4629744.png";